import Nullstack from 'nullstack';
export default function IconJacket({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-jacket",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 3l-4 5l-4 -5"
  }), "   ", Nullstack.element("path", {
    d: "M12 19a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-8.172a2 2 0 0 1 .586 -1.414l.828 -.828a2 2 0 0 0 .586 -1.414v-2.172a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2.172a2 2 0 0 0 .586 1.414l.828 .828a2 2 0 0 1 .586 1.414v8.172a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z"
  }), "   ", Nullstack.element("path", {
    d: "M20 13h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }), "   ", Nullstack.element("path", {
    d: "M4 17h3a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
  }), "   ", Nullstack.element("path", {
    d: "M12 19v-11"
  }), " ");
}